import type { TeamTaskBucket } from '../../data-access';
import type { TeamTasksGroupBy } from './utils';
import type { TeamTasksLayout } from './TeamTasksView/types';

export type TeamTFunction = (
  key: string,
  options?: Record<string, unknown> & { defaultValue?: string }
) => string;

export const getTeamRoleLabel = (t: TeamTFunction, role?: string) => {
  if (role === 'owner' || role === 'admin' || role === 'member') {
    return t(`team.roles.${role}`);
  }

  return t('team.roles.member');
};

export const getTeamMemberFallbackName = (t: TeamTFunction, index: number) =>
  t('team.common.memberWithIndex', { index: index + 1 });

export const getTeamCurrentUserLabel = (t: TeamTFunction, name: string) =>
  t('team.common.youName', { name });

export const getTeamTaskBucketLabel = (t: TeamTFunction, bucket: TeamTaskBucket) =>
  t(`team.tasks.buckets.${bucket}`);

export const getTeamTasksGroupLabel = (t: TeamTFunction, groupBy: TeamTasksGroupBy) =>
  t(`team.tasks.groups.${groupBy}`);

export const getTeamTasksLayoutLabel = (t: TeamTFunction, layout: TeamTasksLayout) =>
  t(`team.tasks.layouts.${layout}`);

export const getTeamTasksFilterLabel = (t: TeamTFunction, value: string) =>
  t(`team.tasks.filters.${value}`);
